import script from "./TestPanelContent.vue?vue&type=script&setup=true&lang=js"
export * from "./TestPanelContent.vue?vue&type=script&setup=true&lang=js"

import "./TestPanelContent.vue?vue&type=style&index=0&id=6e0d5636&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e0d5636"]])

export default __exports__